import { render, staticRenderFns } from "./cursos-detalles-resultado.vue?vue&type=template&id=a10f4ad0&scoped=true&"
import script from "./cursos-detalles-resultado.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles-resultado.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-detalles-resultado.vue?vue&type=style&index=0&id=a10f4ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10f4ad0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VRow,VSpacer})
